import { CheckBadgeIcon } from "@heroicons/react/24/outline";
import { RegularSelectInput, Show, TextArea } from "components/core";

import { FC } from "react";
import { FormikProps } from "formik";
import { GetOfferPayment_getOfferPayment } from "_graphql/visal/queries/__generated__/GetOfferPayment";

export interface ApprovePaymentFormProps {
  form: FormikProps<any>;
  payment?: GetOfferPayment_getOfferPayment | undefined;
}

const ApprovePaymentForm: FC<ApprovePaymentFormProps> = ({ form, payment }) => {
  const details = payment?.payment_details
    ? JSON.parse(payment.payment_details)
    : null;
  const currency = details?.conversion?.currency || "USD";
  return (
    <div className="space-y-1">
      {/* {JSON.stringify(payment, null, 2)} */}
      {/* Removed divide-y for cleaner spacing */}
      {/* Offer Information Section */}
      <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm">
        <h3 className="text-base font-semibold leading-6 text-gray-900 dark:text-gray-100 mb-3">
          Payment Details
        </h3>
        <dl className="space-y-2">
          {/* Display Originally Proposed Percentage */}
          <div className="flex justify-between items-center">
            <dt className="text-sm font-medium text-gray-600 dark:text-gray-400">
              Payment Amount:
            </dt>
            <dd className="text-sm font-semibold text-primary-600 dark:text-primary-400">
              {/* Use toFixed for consistent decimal places, handle potential undefined */}
              {currency} {payment?.payment_amount ?? "N/A"}
            </dd>
          </div>

          {/* Display Maximum Available Percentage */}
          <div className="flex justify-between items-center">
            <dt className="text-sm font-medium text-gray-600 dark:text-gray-400">
              Payment Bank:
            </dt>
            <dd className="text-sm font-semibold text-gray-900 dark:text-gray-100">
              {details?.payment_from?.bank_name ?? "N/A"}
            </dd>
          </div>
          {/* Display Maximum Available Percentage */}
          <div className="flex justify-between items-center">
            <dt className="text-sm font-medium text-gray-600 dark:text-gray-400">
              Receiving Bank:
            </dt>
            <dd className="text-sm font-semibold text-gray-900 dark:text-gray-100">
              {details?.payment_to ?? "N/A"}
            </dd>
          </div>
          {/* Display Maximum Available Percentage */}
          <div className="flex justify-between items-center">
            <dt className="text-sm font-medium text-gray-600 dark:text-gray-400">
              Payment type:
            </dt>
            <dd className="text-sm font-semibold text-gray-900 dark:text-gray-100">
              {details?.payment_type ?? "N/A"}
            </dd>
          </div>
          {/* Display Maximum Available Percentage */}
          <div className="flex justify-between items-center">
            <dt className="text-sm font-medium text-gray-600 dark:text-gray-400">
              Payment Recorded At:
            </dt>
            <dd className="text-sm font-semibold text-gray-900 dark:text-gray-100">
              {payment?.created_at ?? "N/A"}
            </dd>
          </div>
        </dl>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-3 pt-3 border-t border-gray-200 dark:border-gray-700">
          Please review the payment details above. If everything looks correct,
          you can proceed to approve the payment. If you need to make changes,
          please update the fields accordingly.
        </p>
      </div>
      {/* {JSON.stringify(form.values, null, 2)} */}
      {/* Status Selection Section */}
      <div>
        <RegularSelectInput
          id={"status"}
          label={"Approval Status"}
          {...form}
          options={[
            {
              label: "Approve",
              value: "APPROVED",
            },
            {
              label: "Decline",
              value: "REJECTED",
            },
          ]}
        />
      </div>
      <Show if={Boolean(form.values.status === "APPROVED")}>
        <div className="space-y-3 pt-3">
          <div className="rounded-md bg-green-50 p-4 dark:bg-green-500/15 dark:outline dark:outline-green-500/25">
            <div className="flex">
              <div className="shrink-0">
                <CheckBadgeIcon
                  aria-hidden="true"
                  className="size-5 text-green-400"
                />
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-green-800 dark:text-red-200">
                  By approving this payment, you confirm that all details are
                  accurate and compliant with company policies.
                </h3>
              </div>
            </div>
          </div>
        </div>
      </Show>
      <Show if={Boolean(form.values.status === "REJECTED")}>
        <div className="pt-3">
          {/* Input */}
          <div className="flex flex-col w-full pt-4 border-t ">
            <TextArea
              id="message"
              label="Reason for Declining Payment"
              {...form}
              className="w-full"
              placeholder="Type your message here..."
            />
          </div>
        </div>
      </Show>
    </div>
  );
};

export default ApprovePaymentForm;
